import { Panel, Label } from '@playcanvas/pcui/react';
import React, { useState, useEffect } from 'react';

import { SetProperty, ObserverData } from '../../types';

const LodsPanel: React.FC<{
    lodsData: ObserverData['lods'],
    setProperty: SetProperty
}> = ({ lodsData, setProperty }) => {
    // Provide default values in case lodsData is undefined
    const { available = [], selected = '', loading = false } = lodsData || {};
    const [localSelected, setLocalSelected] = useState(selected);

    // Update local state when props change
    useEffect(() => {
        setLocalSelected(selected);
    }, [selected]);

    // Sort LODs by level (0 = highest detail, higher numbers = lower detail)
    const sortedLods = [...available].sort((a, b) => a.level - b.level);

    return (
        <Panel headerText='LEVEL OF DETAIL' class='lods-panel' collapsible={true} enabled={available.length > 1}>
            {loading && <Label text='Loading...' class='lod-loading' />}
            <div className='lod-list'>
                {sortedLods.map((lod) => {
                    const isSelected = localSelected === lod.name;
                    const displayName = `LOD ${lod.level} (${lod.filename})`;
                    
                    return (
                        <div
                            key={lod.name}
                            className={isSelected ? 'lod-item-selected' : 'lod-item'}
                            onClick={() => {
                                // Update local state immediately
                                setLocalSelected(lod.name);
                                
                                // Update the observer
                                setProperty('lods.selected', lod.name);
                            }}
                        >
                            {displayName}
                        </div>
                    );
                })}
            </div>
        </Panel>
    );
};

export default LodsPanel; 